import { createSelector } from 'reselect';
import { workSizeDetails } from './work_sizes';

const pricingSelector = ({ canvas: { pricing } }) => pricing;

// R9: every reason gets a string. A group with no explanation reads as a bug, and
// `no_discount` / `unpublished` fire on groups whose configuration is perfectly intact.
const REASONS = {
  changed: (n, nonGlareOnly) => (
    nonGlareOnly
      ? `re-select Non-Glare on ${ n } item${ n === 1 ? '' : 's' }`
      : `${ n } item${ n === 1 ? '' : 's' } changed`
  ),
  removed: () => 'items removed',
  unavailable: () => 'art no longer available',
  unpublished: () => 'original wall is no longer available',
  no_discount: () => 'this wall has no discount',
  missing_source: () => 'original wall no longer exists'
};

export const panelGroups = createSelector(
  workSizeDetails,
  pricingSelector,
  (works, pricing) => {
    const byId = {};
    works.forEach((w) => { byId[w.wallPictureId] = w; });

    if (!pricing) {
      return [{
        sourceWallId: null, name: null, badge: null, status: null, complete: false, works
      }];
    }

    const groups = pricing.groups.map((g) => {
      const reason = REASONS[g.reason] ? REASONS[g.reason](g.changedCount, g.nonGlareOnly) : null;
      const lostBadge = reason ? 'DISCOUNT LOST' : null;
      return {
        sourceWallId: g.sourceWallId,
        name: g.name,
        times: g.times,
        itemsPrice: g.itemsPrice,
        discount: g.discount,
        // `complete` comes from the server (R9: complete means EARNED). Never re-derive
        // it from discount/status here, or the badge drifts out of step with the total.
        complete: g.complete,
        badge: g.complete ? `−${ g.discountPercent }%` : lostBadge,
        status: reason,
        works: g.wallPictureIds.map((id) => byId[id]).filter(Boolean)
      };
    });

    const loose = pricing.looseWallPictureIds.map((id) => byId[id]).filter(Boolean);
    const unassigned = works.filter((w) => !w.wallPictureId);
    const other = [...loose, ...unassigned];
    if (other.length) {
      groups.push({
        sourceWallId: null,
        name: 'Other items',
        times: 0,
        itemsPrice: 0,
        discount: 0,
        complete: false,
        badge: null,
        status: null,
        works: other
      });
    }
    return groups;
  }
);
